import {Directive, ElementRef, HostListener} from '@angular/core';

@Directive({
    selector: '[cardToggleEvent]'
})
export class CardToggleDirective {
    constructor(private el: ElementRef) { }

    @HostListener('click', ['$event'])
    onToggle($event: any) {
        $event.preventDefault();
        this.el.nativeElement.classList.toggle('icon-up');
    }
}



// WEBPACK FOOTER //
// /builds/yaratechnologies/talkative-parents-portal/src/app/shared/card/card-toggle.directive.ts